import { BundleFiltersModel } from '../../../api/bundle/models/bundle-filters.model'
import { store } from '../../../store'
import { bundleActions } from '../store/bundle-slice'
import api from '../../../api'
import { BUNDLE_ITEMS_PER_PAGE } from '../../../constant'
import { BundleHistoryModel } from '../../../api/bundle/models/bundle-history.model'
import { NotifierType } from '../../../components/Notifier'

export default class BundlesService {
  static fetchBundles = (filters: BundleFiltersModel, pageNumber: number): Promise<unknown> => {
    return Promise.resolve(store.dispatch(bundleActions.setPageNumber(pageNumber)))
      .then(() => Promise.resolve(store.dispatch(bundleActions.setLoading(true))))
      .then(() => {
        const pageToFirst = pageNumber * BUNDLE_ITEMS_PER_PAGE

        return api.bundle.fetchBundles(filters, pageToFirst)
      })
      .then(response => {
        if (!response.data?.bundles) {
          return
        }

        return store.dispatch(
          bundleActions.setData({
            data: [...response.data.bundles.nodes],
            totalItemsCount: response.data.bundles.totalCount,
          })
        )
      })
      .catch(() => [])
      .finally(() => void store.dispatch(bundleActions.setLoading(false)))
  }

  static fetchBundle = (id: string): Promise<unknown> => {
    return Promise.resolve(store.dispatch(bundleActions.setLoading(true)))
      .then(() => {
        return api.bundle.fetchBundle(id)
      })
      .then(response => {
        if (!response.data?.node) {
          return
        }

        return store.dispatch(bundleActions.setSelectedBundle(response.data.node))
      })
      .catch(() => [])
      .finally(() => void store.dispatch(bundleActions.setLoading(false)))
  }

  static fetchBundleHistory = (id: string): Promise<unknown> => {
    return Promise.resolve(store.dispatch(bundleActions.setHistoryLoading(true)))
      .then(() => {
        return api.bundle.fetchBundleHistory(id)
      })
      .then(response => {
        if (!response.data?.bundleHistory.edges) {
          return
        }

        const bundleHistory: BundleHistoryModel[] = response.data.bundleHistory.edges.map(edge => ({
          ...edge.node,
          user: {
            ...edge.node.user,
          },
        }))

        return store.dispatch(bundleActions.setBundleHistory(bundleHistory))
      })
      .catch(() => [])
      .finally(() => void store.dispatch(bundleActions.setHistoryLoading(false)))
  }

  static releaseBundle = (
    id: string,
    addNotification: (type: NotifierType, text: string | string[]) => void,
    t: (key: string) => string,
    setModalOpen: (open: boolean) => void,
    filters: BundleFiltersModel,
    pageNumber: number
  ): Promise<unknown> => {
    return api.bundle
      .freeBundle(id)
      .then(response => {
        if (
          !response.data?.freeBundle.bundle.bundleSchedules ||
          response.data?.freeBundle.bundle.bundleSchedules.length === 0 ||
          response.data?.freeBundle.bundle.bundleSchedules[0].status !== 'freed'
        ) {
          return
        }

        void store.dispatch(
          bundleActions.setSelectedBundleSchedules(response.data.freeBundle.bundle.bundleSchedules)
        )

        addNotification(NotifierType.SUCCESS, t('bundle.releaseSuccess'))

        setModalOpen(false)
      })
      .then(() => {
        const pageToFirst = pageNumber * BUNDLE_ITEMS_PER_PAGE

        return api.bundle.fetchBundles(filters, pageToFirst)
      })
      .then(response => {
        if (!response.data?.bundles) {
          return
        }

        return store.dispatch(
          bundleActions.setData({
            data: [...response.data.bundles.nodes],
            totalItemsCount: response.data.bundles.totalCount,
          })
        )
      })
  }

  static releaseBundleSchedule = (
    scheduleId: string,
    addNotification: (type: NotifierType, text: string | string[]) => void,
    t: (key: string) => string,
    filters: BundleFiltersModel,
    pageNumber: number
  ): Promise<unknown> => {
    return api.bundle
      .freeBundleSchedule(scheduleId)
      .then(response => {
        if (!response.data?.freeBundleSchedule.bundleSchedule) {
          return
        }

        void store.dispatch(
          bundleActions.updateSelectedBundleSchedule({
            schedule: response.data.freeBundleSchedule.bundleSchedule,
          })
        )

        addNotification(NotifierType.SUCCESS, t('bundle.releaseScheduleSuccess'))
      })
      .then(() => {
        const pageToFirst = pageNumber * BUNDLE_ITEMS_PER_PAGE

        return api.bundle.fetchBundles(filters, pageToFirst)
      })
      .then(response => {
        if (!response.data?.bundles) {
          return
        }

        return store.dispatch(
          bundleActions.setData({
            data: [...response.data.bundles.nodes],
            totalItemsCount: response.data.bundles.totalCount,
          })
        )
      })
  }
}
